import React from "react";

const Last5ServiceDetails = ({ data = [] }) => {
    return (
        <div className="bg-white rounded-lg shadow p-2 border max-w-[1200px] w-full">
            <h2 className="text-xl font-bold text-gray-800 p-2">
                Last 5 Service Details
            </h2>

            <div className="overflow-x-auto h-96">
                <table className="w-full">
                    <thead>
                        <tr className="bg-[#1467B3] text-white">
                            <th className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                                Service Date
                            </th>
                            <th className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                                Workshop Name
                            </th>
                            <th className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                                Vehicle Registration No
                            </th>
                            <th className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                                Model
                            </th>
                            <th className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                                Service Type
                            </th>
                            <th className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                                Service TAT (Hours)
                            </th>
                            <th className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                                Invoice Amount
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {data && data.length > 0 ? (
                            data.map((row, index) => (
                                <tr
                                    key={index}
                                    className={
                                        index % 2 === 0 ? "bg-gray-50" : "bg-white"
                                    }
                                >
                                    <td className="px-4 py-3 text-gray-700">
                                        {row?.LAST_SERVICE_DATE || "-"}
                                    </td>
                                    <td className="px-4 py-3 text-gray-900 font-semibold">
                                        {row?.DLR_NAME || "-"}
                                    </td>
                                    <td className="px-4 py-3 text-gray-700">
                                        {row?.VEHICLE_REGISTRATION_NUMBER || "-"}
                                    </td>
                                    <td className="px-4 py-3 text-gray-700">
                                        {row?.SR_ASSET_PL || "-"}
                                    </td>
                                    <td className="px-4 py-3 text-gray-700">
                                        {row?.SR_SR_CAT_TYPE_CD || "-"}
                                    </td>
                                    <td className="px-4 py-3 text-gray-700">
                                        {row?.TAT_Hours ?? 0}
                                    </td>
                                    <td className="px-4 py-3 text-gray-700">
                                        {row?.Bill_Amount
                                            ? Number(row.Bill_Amount).toFixed(2)
                                            : "0.00"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan="7"
                                    className="px-4 py-3 text-center text-gray-500"
                                >
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Last5ServiceDetails;
